module.exports = __webpack_public_path__ + "assets/img/researchReport.6d67dda2.png";